import React from 'react';
import { iconCategoryCssClass } from '../../data/utils';
import Jersey from '../../common/jerseys/Jersey';

function MultiLiveMatchBox(props) {
    const parts = props.score.combinedScore.split(' - ');
    const team1Score = parts[0];
    const team2Score = parts[1];

    function handleClick() {
        props.addMatch(props.uniqueId);
    }

    const icoCategory = iconCategoryCssClass(props.sportRef, props.categoryRef, props.iconClass);

    let periodAndMinute = props.score.periodo;
    if (props.score.currentMinute) {
        periodAndMinute += ' - ' + props.score.currentMinute;
    }

    return (
        <div className="box-slider-partite position-relative pointer" onClick={handleClick}>
            <div className="d-flex flex-column">
                <div className="titolo-box d-flex align-items-center justify-content-between">
                    <div className={`titolo__box__immagine img-fluid img-flags margine-dx-mezzo ico-cat ${icoCategory}`}></div>
                    <span className="titolo__box__evento">{props.tournamentDesc}</span>
                    <span className="titolo__box__tempo margine-sx">{periodAndMinute}</span>
                </div>
                <div className="body-box-partite d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center margine-giu-mezzo">
                        <div className="d-flex items-center">
                            {props.team2 &&
                                <Jersey data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                            }
                            <span>{props.team1}</span>
                        </div>
                        <span className="grassetto">{team1Score}</span>
                    </div>
                    {props.team2 &&
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex items-center">
                                <Jersey data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                                <span>{props.team2}</span>
                            </div>
                            <span className="grassetto">{team2Score}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default MultiLiveMatchBox;
